var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer-contact-column-2 footer-contact-column caption"
  }, [_c('div', {
    staticClass: "column-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('footer.social_media')))])]), _vm._m(1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/arrow-right-black-extended.svg"),
      "alt": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/linkedin-icon.svg"),
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/swiss-engineers-united",
      "target": "_blank"
    }
  }, [_vm._v("Linkedin")])]);

}]

export { render, staticRenderFns }